import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { AuthenticationService } from './services/authentication.service';
import { UserPartner } from './models/api/UserPartner';
import { Subscription } from 'rxjs';
import { RoleConstants } from './@shared/constants/role.constant';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { BreadcrumbElement } from './models/ui/breadcrumb-element.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [RoleConstants],
})
export class AppComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();

  title = 'BusinessCenter';
  pageName: string;
  subBreadcrumbs: BreadcrumbElement[] = [];
  userName: string = '';
  userRoles: string[] = [];
  partnerName: string = '';
  isLsAdmin: boolean = false;
  isDirEndUser: boolean = false;
  isLoggedIn: Boolean = false;
  version: string = '';
  currentYear = new Date().getFullYear();
  menuVisible: boolean = false;
  partnerIsActive: boolean = true;
  isTestingPartner: boolean = false;
  partners: UserPartner[];
  isIframe = false;
  loginDisplay = false;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    public constants: RoleConstants,
    private oidcSecurityService: OidcSecurityService
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          // detect browser reload
          this.authenticationService.restorePermissions();
          if (!window.location.pathname.includes('/auth-callback')) {
            this.oidcSecurityService.checkAuth().subscribe();
          }
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
